<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Pagina di login per il servizio -->
    <SalabamLoginPage :service_title="service_title" :service_name="service_name"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SalabamLoginPage from '@/components/salabam/SalabamLoginPage'

export default {
  name: 'SalabamBooking',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Booking.com", link : 'conv-booking' } ],

        // variabili che definiscono il servizio Booking con la quale
        // configuriamo la pagina di login.
        service_title: "Booking.com",
      service_name: "booking",
    }
  },
  components: {
    PageTagline,
    SalabamLoginPage
  }
}
</script>

<style scoped></style>